import { checkElementInView } from '../__utils/checkElementInView';

const animationSelectors =
	'.content-wrapper:not(.no-animations) > *:not(.acf-block), .content-wrapper:not(.no-animations) > .acf-block:not(.no-animations) > *, .animate-in';
const sections = document.querySelectorAll(animationSelectors);

let loadCounter = 0;

const showSection = (e) => {
	e.classList.add('in-viewport');
};

const hideSection = () => {};

const atTop = () => {
	document.body.classList.remove('scrolled');
};

const notAtTop = () => {
	document.body.classList.add('scrolled');
};

const isSectionVisible = (section) => {
	const rect = section.getBoundingClientRect();

	if (
		!section.classList.contains('no-delay') &&
		rect.top < document.documentElement.clientHeight
	) {
		section.style.setProperty('--transitionDelay', `${loadCounter * 0.2}s`);

		section.classList.add('in-viewport');

		if (rect.top >= 0) {
			loadCounter++;
		}
	}
};

const sectionsInView = () => {
	if (sections.length) {
		sections.forEach((section) => {
			isSectionVisible(section);
		});

		checkElementInView(animationSelectors, showSection, hideSection, {
			root: null,
			rootMargin: '0px 0px -20% 0px',
			threshold: [0],
		});
	}

	checkElementInView('#top', atTop, notAtTop, {
		root: null,
		rootMargin: '12px 0px 0px 0px',
		threshold: [1],
	});
};

export default sectionsInView;
